export default {
  state: {
    cardAdditionMenu: {
      isVisible: false,
      inputs: [
        {
          display: 'Número do cartão',
          placeHolder: 'Número',
          type: 'text',
          required: true,
          format: 'cardNumber'
        },
        {
          display: 'Nome do titular',
          placeHolder: 'Nome',
          type: 'text',
          required: true
        },
        {
          display: 'Validade',
          placeHolder: 'Validade',
          type: 'text',
          required: true,
          half: true,
          format: 'cardDate'
        },
        {
          display: 'CVV',
          placeHolder: 'CVV',
          type: 'text',
          required: true,
          half: true,
          format: 'cardCVV'
        },
        {
          display: 'Tornar este cartão principal',
          readOnlyCondition: 'emptyCardList',
          type: 'checkbox',
          half: false,
          format: 'checkbox'
        }
      ]
    }
  },
  mutations: {
    setCardAdditionMenuVisibility (state) {
      state.cardAdditionMenu.isVisible = !state.cardAdditionMenu.isVisible
    }
  },
  actions: {
    changeCardAdditionMenuVisibility ({ commit }) {
      commit('setCardAdditionMenuVisibility')
    }
  },
  getters: {
    cardAdditionMenu: (state) => state.cardAdditionMenu
  }
}
